import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "checkbox" };
const _hoisted_2 = ["id", "disabled", "required"];
const _hoisted_3 = ["for"];
import { toBoolean } from "./fieldValues";
import { useFieldControl, useFieldModel } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlBool',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange } = useFieldControl(props, emit, 'FieldControlBool');
        const model = useFieldModel(() => toBoolean(props.data));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                    onChange: _cache[1] || (_cache[1] = ($event) => (_unref(emitChange)(_unref(model)))),
                    type: "checkbox",
                    id: __props.fieldId,
                    disabled: _unref(fieldOptions).disabled ?? undefined,
                    required: _unref(fieldOptions).required ?? undefined,
                    class: "form__control"
                }, null, 40, _hoisted_2), [
                    [_vModelCheckbox, _unref(model)]
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("label", { for: __props.fieldId }, null, 8, _hoisted_3)
            ]));
        };
    }
});
